module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c32885db098a1e103a46e711e9244946.png";